@import (reference) '../../../../../constants/spacing.module.less';

.status-container {
  display: inline-flex;
  align-items: center;
  padding: 2px @space-8;
  border-radius: 4px;
  width: auto;
  cursor: pointer;
}

.status-body {
  display: inline-flex;
  align-items: baseline;
  gap: @space-4;
  line-height: 1.3;
}

.status-container-assigned {
  border: 1px solid var(--blue-400);
  background-color: var(--blue-200);
}

.status-container-assigned:hover {
  background-color: var(--blue-300);
}

.status-container-in-progress {
  border: 1px solid var(--purple-cab1ff);
  background-color: var(--purple-F6F2FF);
}

.status-container-in-progress:hover {
  background-color: var(--purple-EEE8FF);
}

.status-container-overdue {
  border: 1px solid var(--red-F1C1C1);
  background-color: var(--red-F8DEDE);
}

.status-container-overdue:hover {
  background-color: var(--red-F1C1C1);
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: @space-8;
}

.status-dot-assigned {
  background-color: var(--blue-600);
}

.status-dot-in-progress {
  background-color: var(--purple-600);
}

.status-dot-overdue {
  background-color: var(--red-FF4422);
}

.audit-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.due-date {
  color: var(--grey-600);
  font-size: 12px;
}
